export default __webpack_public_path__ + "static/media/error.76ba3e1b.png";